import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { createCategory } from "../../../services/admin/category"; // adjust path if needed

function AddAdminCategory() {
    const navigate = useNavigate();

    const [formData, setFormData] = useState({
        name: "",
    });

    const [loading, setLoading] = useState(false);
    const [error, setError] = useState<string | null>(null);

    const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        setFormData({
            ...formData,
            [e.target.name]: e.target.value,
        });
    };

    const handleSubmit = async (e: React.FormEvent) => {
        e.preventDefault();
        setError(null);
        setLoading(true);

        const res = await createCategory(formData);

        if (res.success) {
            // Optional: show success toast or message
            navigate("/admin/category"); // redirect to category list
        } else {
            setError(res.error);
        }

        setLoading(false);
    };

    return (
        <div className="p-6 space-y-6">
            {/* Header with back button */}
            <div className="flex items-center justify-between">
                <h1 className="text-2xl font-semibold text-gray-800">Add Category</h1>
                <button
                    onClick={() => navigate(-1)}
                    className="flex items-center text-sm text-gray-600 hover:text-[#009FE3] transition"
                >
                    <ArrowLeft className="w-4 h-4 mr-1" />
                    Back
                </button>
            </div>

            {/* Form */}
            <form onSubmit={handleSubmit} className="space-y-4 max-w-[600px]">
                {/* Error Message */}
                {error && (
                    <div className="text-sm text-red-600 bg-red-100 p-2 rounded">
                        {error}
                    </div>
                )}

                {/* Name */}
                <div>
                    <label className="block text-sm font-medium text-gray-700 mb-1">
                        Category Name
                    </label>
                    <input
                        type="text"
                        name="name"
                        value={formData.name}
                        onChange={handleChange}
                        required
                        className="w-full px-4 py-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-[#009FE3]"
                    />
                </div>

                {/* Submit Button */}
                <button
                    type="submit"
                    disabled={loading}
                    className={`w-full py-2 px-4 text-white rounded-lg transition ${
                        loading
                            ? "bg-[#009FE3]/50 cursor-not-allowed"
                            : "bg-[#009FE3] hover:bg-[#008AC6]"
                    }`}
                >
                    {loading ? "Adding..." : "Add Category"}
                </button>
            </form>
        </div>
    );
}

export default AddAdminCategory;
